import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.129 12.75a2.56 2.56 0 0 0-3.55-3.55zM9.87 9.908a2.56 2.56 0 0 0 3.55 3.55z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.132 11.884a1 1 0 0 1 0-1.11L3.68 8.453c.65-.975 1.428-1.79 2.293-2.444L8.955 8.99a3.84 3.84 0 0 0 5.383 5.383l2.847 2.847c-4.369 2.645-10.402 1.64-13.505-3.015zm15.896 4.765a10 10 0 0 0 2.293-2.444l1.547-2.321a1 1 0 0 0 0-1.11l-1.547-2.321c-3.104-4.655-9.137-5.66-13.506-3.016l2.847 2.847a3.84 3.84 0 0 1 5.383 5.383z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M18.587 20.099 3.87 5.382l.905-.905 14.717 14.717z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }